import React from 'react';
import { useSelector, useDispatch } from 'react-redux'

// Redux slices
import { closeModal, openModal } from '../../appSlice'

/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// SemanticUI components
import { Container, Modal, Icon, Grid, GridRow, GridColumn, Header, Flag, Accordion, Segment, Label } from 'semantic-ui-react';


registerLocale('de', de);
setDefaultLocale('de');


/**
 * 
 * @returns 
 */
const Max2ModalProfile = () => {
    // global State
    const dispatch = useDispatch();
    const open          = useSelector((state) => state.app.modal.profile.open);
    const userDetails   = useSelector((state) => state.app.modal.profile.data);

    // check if modal is active
    if (!open) {
        return <></>
    };


    // build group checkboxes
    let groupCheckboxes = [];
    for (const key in userDetails.groups) {
        if (Object.prototype.hasOwnProperty.call(userDetails.groups, key)) {
            const group = userDetails.groups[key];
            groupCheckboxes.push(<><Icon circular name='users' />{group.name}<br /></>);
        }
    }

    // Reference-User
    let ref_user = '';
    if (typeof userDetails?.reference_details?.uname !== 'undefined') {
        ref_user = userDetails.reference_details.uname;
    }

    // build assigned objectcodes list
    let objectcodesGrouped = {};
    userDetails?.objectCodes?.forEach(objectCode => {
        if (typeof objectcodesGrouped[objectCode.zgb_id] === 'undefined') {
            objectcodesGrouped[objectCode.zgb_id] = {
                key: objectCode.zgb_id,
                title: objectCode.zgb_name,
                objectCodes: [],
                content: []
            }
        }
        objectcodesGrouped[objectCode.zgb_id].objectCodes.push(objectCode.name);
        objectcodesGrouped[objectCode.zgb_id].content.push(<>&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;{objectCode.name}<br /></>)
    });
    const objectCodesAccordion = <Accordion defaultActiveIndex={[0]} panels={objectcodesGrouped} exclusive={false} />

    // Date formatting
    const regdate   = userDetails.regdate ? format(new Date(userDetails.regdate * 1000), 'dd.MM.yyyy HH:mm') + ' Uhr' : '';
    const lastlogin = userDetails.lastlogin ? format(new Date(userDetails.lastlogin * 1000), 'dd.MM.yyyy HH:mm') + ' Uhr' : '';

  
    return (
        <Modal closeIcon dimmer="blurring" open={open} size="large" onClose={() => dispatch(closeModal('profile'))}>
            <Modal.Header>Benutzerprofil &laquo;{userDetails.uname}&raquo;</Modal.Header>
            <Modal.Content scrolling>
                <Segment>
                    <Grid style={{margin: '25px'}}>
                        <GridRow> 
                            <GridColumn width={8}>
                                <Header as='h4'>Details</Header>
                                <Grid>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>Benutzerkennung</GridColumn><GridColumn width={11}>{userDetails.uname}</GridColumn></GridRow>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>E-Mail</GridColumn><GridColumn width={11}>{userDetails.email}</GridColumn></GridRow>
                                </Grid>
                                <br /><br />
                                <Grid>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>Anzeigename</GridColumn><GridColumn width={11}>{userDetails.displayname}</GridColumn></GridRow>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>Vorame</GridColumn><GridColumn width={11}>{userDetails.forename}</GridColumn></GridRow>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>Nachname</GridColumn><GridColumn width={11}>{userDetails.surename}</GridColumn></GridRow>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>Telefon</GridColumn><GridColumn width={11}>{userDetails.telephone}</GridColumn></GridRow>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>Anzeigesprache</GridColumn><GridColumn width={11}><Flag name={userDetails.language === 'german' ? 'de' : 'uk'} /></GridColumn></GridRow>
                                </Grid>
                                <br /><br />
                                <Grid>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>Agentur</GridColumn><GridColumn width={11}>{userDetails?.agency?.name}</GridColumn></GridRow>
                                </Grid>
                                <br /><br />
                                <Grid>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>Referenz-Benutzer</GridColumn><GridColumn width={11}>
                                        <Label as='a' onClick={()=>{dispatch(openModal({type: 'profile', data: userDetails.reference_details}))}}>
                                            <Icon name='user circle' /> {ref_user}
                                        </Label>
                                        </GridColumn>
                                    </GridRow>
                                </Grid>
                                <br /><br />
                                <Grid>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>Letzter Login</GridColumn><GridColumn width={11}>{lastlogin}</GridColumn></GridRow>
                                    <GridRow className='ro_row'><GridColumn width={5} className='ro_label' textAlign='right'>Registrierdatum</GridColumn><GridColumn width={11}>{regdate}</GridColumn></GridRow>
                                </Grid>
                                <br /><br />
                                <Grid>
                                    <GridRow className='ro_row'>
                                    <GridColumn width={5} className='ro_label' textAlign='right'>Gruppenzugehörigkeit</GridColumn>
                                    <GridColumn width={11}>{groupCheckboxes}</GridColumn>
                                    </GridRow>
                                </Grid>
                            </GridColumn>

                            <GridColumn width={4}>
                                <Header as='h4'>Rechte/Zugriffssteuerung</Header>
                                <Container style={{maxHeight: '800px', overflow: 'auto', borderTop: '1px solid silver', padding: '10px'}}>
                                    <label>Systemsteuerung</label><br />
                                    <div style={{padding: '10px', marginBottom: '25px'}}>
                                        {userDetails?.permissions?.system?.read && (<><Icon circular name='check' />Lesezurgriff<br /></>)}
                                        {userDetails?.permissions?.system?.write && (<><Icon circular name='check' />Schreibzugriff<br /></>)}
                                    </div>

                                    <label>Hotel/Objekt</label><br />
                                    <div style={{padding: '10px', marginBottom: '25px'}}>
                                        {userDetails?.permissions?.object?.read && (<><Icon circular name='check' />Lesezurgriff<br /></>)}
                                        {userDetails?.permissions?.object?.write && (<><Icon circular name='check' />Schreibzugriff<br /></>)}
                                        {userDetails?.permissions?.object?.addMedia && (<><Icon circular name='check' />Hotelbilder<br /></>)}
                                        {userDetails?.permissions?.object?.descriptions && (<><Icon circular name='check' />Hotelbeschreibungen<br /></>)}
                                        {userDetails?.permissions?.object?.contracts && (<><Icon circular name='check' />Verträge<br /></>)}
                                        {userDetails?.permissions?.object?.exports && (<><Icon circular name='check' />Exporte<br /></>)}
                                    </div>

                                    <label>Vertrag</label><br />
                                    <div style={{padding: '10px', marginBottom: '25px'}}>
                                        {userDetails?.permissions?.contract?.read && (<><Icon circular name='check' />Lesezurgriff<br /></>)}
                                        {userDetails?.permissions?.contract?.write && (<><Icon circular name='check' />Schreibzugriff<br /></>)}
                                        {userDetails?.permissions?.contract?.headoffice && (<><Icon circular name='check' />Erweiterte Ansicht / HeadOffice<br /></>)}
                                        {userDetails?.permissions?.contract?.management && (<><Icon circular name='check' />Vertragsadministration<br /></>)}
                                    </div>

                                    <label>Allotments</label><br />
                                    <div style={{padding: '10px', marginBottom: '25px'}}>
                                        {userDetails?.permissions?.allotments?.read && (<><Icon circular name='check' />Lesezurgriff<br /></>)}
                                        {userDetails?.permissions?.allotments?.write && (<><Icon circular name='check' />Schreibzugriff<br /></>)}
                                    </div>
                                </Container>
                            </GridColumn>

                            <GridColumn width={4}>
                                <Header as='h4'>Objektcode-Zuordnungen</Header>
                                <Container style={{maxHeight: '800px', overflow: 'auto', borderTop: '1px solid silver', padding: '10px'}}>
                                    {objectCodesAccordion}
                                </Container>
                            </GridColumn>
                        </GridRow>
                    </Grid>
                </Segment>
            </Modal.Content>
        </Modal>
    )
}

export default Max2ModalProfile;